<template>
  <div class="custom-multistep-selector">
    <div class="custom-multistep-selector__wrapper">
      <div class="custom-multistep-selector__content">
        <div
          class="custom-multistep-selector__content__selected"
          v-if="internalValue"
        >
          <div class="custom-multistep-selector__content__selected__image">
            <img :src="internalValue.image" alt="" />
          </div>
          <div class="custom-multistep-selector__content__selected__title">
            {{ internalValue.name }}
          </div>
        </div>
        <div
          class="custom-multistep-selector__content__not-selected clickable"
          @click="openModal"
          v-else
        >
          <div>
            <div
              class="custom-multistep-selector__content__not-selected__title"
            >
              Escolha do nosso banco de dados
            </div>
            <div class="custom-multistep-selector__content__not-selected__icon">
              <font-awesome-icon
                :icon="['fas', 'hand-pointer']"
              ></font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-multistep-selector__actions">
        <div
          v-if="internalValue"
          class="option option__sync"
          @click="openModal"
        >
          <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon>
        </div>

        <div class="option option__add" @click="handleAdd">
          <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
        </div>

        <div
          class="option option__delete"
          @click="clearSelection"
          v-if="internalValue"
        >
          <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </div>
      </div>
    </div>
  </div>

  <Dialog
    v-model:visible="displayModal"
    :style="{ width: '80vw' }"
    :modal="true"
  >
    <div class="modal-content">
      <div class="modal__options">
        <div
          class="modal__options__item"
          v-for="item in currentOptionsList"
          :key="item.value"
          :class="{ selected: isItemSelected(item) }"
          @click="changeInternalSelection(item)"
        >
          <div class="modal__options__item__image">
            <img :src="item.image" alt="" />
          </div>
          <div class="modal__options__item__name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog'

  export default {
    components: {
      Dialog,
    },
    emits: ['item-selected-event'],
    props: {
      options: {
        type: Object,
        required: true,
      },
      value: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        displayModal: false,
        currentOptionsList: [],
        internalValue: null,
      }
    },
    methods: {
      handleAdd() {
        if (!this.internalValue) {
          this.openModal()
        } else {
          this.selectItem(this.internalValue)
        }
      },
      openModal() {
        this.displayModal = true
      },
      closeModal() {
        this.displayModal = false
      },
      isItemSelected(item) {
        return item.value === this.internalValue?.value
      },
      changeInternalSelection(item) {
        this.internalValue = item
        if (!item.selectable) {
          setTimeout(() => this.handleAdd(), 300)
          return
        }
        this.closeModal()
      },
      selectItem(item) {
        if (item.selectable) {
          this.internalValue = item
          this.$emit('item-selected-event', { selected: item })
        } else if (item.options) {
          this.currentOptionsList = [...item.options]
        }
      },
      clearSelection() {
        this.internalValue = null
      },
    },
    watch: {
      value(newValue) {
        this.internalValue = newValue
      },
      // internalValue(newValue) {
      //   this.$emit('item-selected-event', { selected: newValue })
      // },
      displayModal(newValue) {
        if (newValue === false) {
          if (this.options.options)
            this.currentOptionsList = [...this.options.options]
        }
      },
    },
    mounted() {
      if (this.options.options)
        this.currentOptionsList = [...this.options.options]
      this.internalValue = this.value
    },
  }
</script>

<style lang="scss" scoped>
  .custom-multistep-selector {
    height: 100%;

    display: flex;
    flex-direction: column;

    &__wrapper {
      position: relative;

      border: 1px solid #dee2e6;
      border-radius: 4px;
      min-height: 150px;

      flex-grow: 1;
    }

    &__content {
      height: 100%;
      width: 100%;

      position: absolute;
      top: 0;
      left: 0;

      &__selected {
        height: 100%;

        text-align: center;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &__image {
          width: 120px;
          max-height: 160px;

          img {
            width: 100%;
            height: auto;
            object-fit: cover;
          }
        }
      }

      &__not-selected {
        height: 100%;
        color: #cacaca;
        font-size: 1.5rem;

        text-align: center;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &__icon {
          font-size: 3rem;
        }
      }
    }

    &__actions {
      position: absolute;

      bottom: 10px;
      right: 10px;
      width: auto;

      display: flex;

      .option {
        $defaultColor: rgb(76, 175, 80);

        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        color: white;

        padding: 5px;
        width: 30px;
        height: 30px;

        border: 2px solid #ccc;
        color: $defaultColor;

        transition: box-shadow 0.5s ease, background-color 0.3s ease;

        &:hover {
          border: none;
          box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

          background-color: $defaultColor;

          color: white;
        }

        &:not(:first-child) {
          margin-left: 5px;
        }

        &__delete {
          color: rgb(244, 67, 54);

          &:hover {
            box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

            background-color: rgb(244, 67, 54);
          }
        }
      }
    }
  }

  .modal {
    &-content {
      border: none;
    }

    &__options {
      display: grid;
      grid-template-columns: auto auto auto;
      grid-auto-rows: 160px;
      grid-gap: 20px;
      align-items: stretch;

      &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        padding: 10px;

        border: 1px solid #ccc;
        border-radius: 5px;

        transition: box-shadow 0.4s ease, border 0.4s ease;

        cursor: pointer;

        &.selected {
          border: 2px solid rgb(76, 175, 80);
          box-shadow: 0px 0px 10px #ccc;
        }

        &:hover {
          box-shadow: 0px 0px 10px #ccc;
        }

        &__image {
          text-align: center;
          width: 180px;
          height: 100px;

          img {
            max-width: 80%;
            max-height: 100%;
            object-fit: cover;
          }
        }

        &__name {
          font-size: 0.8rem;
        }
      }
    }
  }
</style>
